export default __webpack_public_path__ + "static/media/buying.81f6e846.png";